const getPageContentContainer = (): HTMLElement => {
  // first, try to use content of the page as a parent element (to avoid overlapping the navbar)
  let element = document.querySelector("#root > section.ant-layout > main.ant-layout-content");
  // if it didn't work, fallback to document's body
  if (!element) {
    element = document.body;
  }
  return element as HTMLElement;
};

export default getPageContentContainer;
